export const twoDigits = (num: number) => (num < 10 ? '0' : '') + num;
